module.exports = __webpack_public_path__ + "img/investment-circle.d059daba.svg";